import { createSlice } from "@reduxjs/toolkit";
import { getCategoryList, saveCategory, deleteCategory } from "../controller/category.controller";
import { Category } from "../types/categoryType";
import { SaveResponse } from "../types/common";

interface CategoryState {
  loading: boolean;
  list: Category[];
  total: { pages: number; data: number };
  response: SaveResponse | null;
  error: string | null;
}

const initialState: CategoryState = {
  loading: false,
  list: [],
  total: { pages: 0, data: 0 },
  response: null,
  error: null,
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    resetCategoryResponse: (state) => {
      state.response = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCategoryList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCategoryList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data?.data ?? [];
        state.total = action.payload.data?.total ?? { pages: 0, data: 0 };
      })
      .addCase(getCategoryList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal memuat data kategori";
      })
      .addCase(saveCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.response = action.payload;
      })
      .addCase(saveCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal menyimpan kategori";
      })
      .addCase(deleteCategory.fulfilled, (state, action) => {
        state.response = action.payload;
      });
  },
});

export const { resetCategoryResponse } = categorySlice.actions;
export default categorySlice.reducer;
